(function (angular) {
	angular.module('bizPartEngage').controller('modules.events', listController);
	angular.module('bizPartEngage').controller('modules.event', indexController);	

	//indexController.$inject = ["modules.event.service", "bizContainerSettings", "$stateParams", "bizContainerModuleEventListService"];
	indexController.$inject = ["$stateParams", "bizEngageService"];
	listController.$inject = ["$stateParams"];

	function listController($stateParams) {
		var vm = this;
		vm.EventFilter = $stateParams.filter;
	}

	function indexController($stateParams, bizEngageService) {
		var vm = this;
		vm.EventId = ~~$stateParams.id;
		vm.EventTab = $stateParams.tab;

		vm.$onInit = function () {
			//TODO CHANGE TO Event, but we dont seem to have a setting for that yet
			bizEngageService.GetMiniJourneySetting('Blog').then(function (response) {
				vm.MiniJourneySettings = response;
				vm.MiniJourneySettings.ShowOnItem = true;//testing
			});			
		}
	}

	//function indexController(eventService, bizContainerSettings, $stateParams, bizContainerModuleEventListService) {
	//	var vm = this;

	//	vm.Event = {};
	//	vm.GetEvent = GetEvent;
	//	vm.EventId = ~~$stateParams.id;
	//	vm.IsLoggedIn = false;
	//	vm.IsInFuture = IsInFuture;
	//	vm.IsToday = IsToday;
	//	vm.ChangeStatus = ChangeStatus;
	//	vm.IsAllowedToBook = IsAllowedToBook;
	//	vm.IsAllowedToCancel = IsAllowedToCancel;
	//	vm.Email = '';
	//	vm.Cancel = '';

	//	function GetEvent() {
	//		vm.DataLoaded = false;
	//		eventService.GetOneEvent(vm.EventId).then(GetEventSuccess);

	//		function GetEventSuccess(response) {
	//			vm.DataLoaded = true;
	//			vm.Event = response.data;

	//			if (bizContainerSettings["CurrentUserId"] > 0) {
	//				vm.IsLoggedIn = true;
	//			}
	//		}
	//	}

	//	function IsAllowedToBook(event) {
	//		if (!vm.DataLoaded) {
	//			return false;
	//		}
	//		if (event.ParticipantCount < event.MaxParticipants
	//			&& (event.UserStatus == 4 || event.UserStatus == 0)
	//			&& vm.IsInFuture(event.RSVPDateTimeUtc) == true) {
	//			return true;
	//		}

	//		return false;
	//	}

	//	function IsAllowedToCancel(event) {
	//		if (!vm.DataLoaded) {
	//			return false;
	//		}
	//		if (event.UserStatus == 3 && vm.IsInFuture(event.RSVPDateTimeUtc) == true) {
	//			return true;
	//		}
	//		return false;
	//	}

	//	function IsToday(datetimeUtc) {
	//		if (vm.DataLoaded) {
	//			if (moment(datetimeUtc).isSame(moment.utc(), 'day')) {
	//				return true;
	//			}
	//			else {
	//				return false;
	//			}
	//		}
	//	}

	//	function IsInFuture(datetimeUtc) {
	//		if (vm.DataLoaded) {
	//			if (moment(datetimeUtc).isAfter(moment.utc())) {
	//				return true;
	//			}
	//			else {
	//				return false;
	//			}
	//		}
	//	}

	//	function ChangeStatus(event, newStatus) {

	//		if (bizContainerSettings["CurrentUserId"] > 0) {
				
	//		}
	//		else {
	//			if (vm.Email != '' && vm.Email.indexOf('@')) { // TODO some kind of validation.

	//			}
	//			else {
	//				return;
	//			}
	//		}

	//		bizContainerModuleEventListService.UpdateParticipationStatus(event.Id, newStatus, vm.Email, vm.Comment).then(UpdateParticipationStatusSuccess);
	//	}

	//	function UpdateParticipationStatusSuccess(response) {
	//		var result = (response.data.d || response.data);
	//		vm.GetEvent();
	//	}

	//	vm.$onInit = function () {
	//		vm.GetEvent();
	//	}
	//}

})(window.angular);
